import {SpinButtonBasicState} from '@fantasmagames/slot/src/modules/keypad/spinbutton/states/SpinButtonBasicState';
import {RecodeSpinButtonModule} from 'src/spinbutton/RecodeSpinButtonModule';
import {SpinButtonEvents} from '@fantasmagames/slot/src/modules/keypad/spinbutton/SpinButtonEvents';

export class RecodeSpinButtonBasicState extends SpinButtonBasicState {
	public onEnterState(): void {
		super.onEnterState();
	}

	public onLeaveState(): void {
		super.onLeaveState();
	}

	protected onCanSpin(): void {
		if (!(this.module as RecodeSpinButtonModule).isWaitingForFreeGames) {
			super.onCanSpin();
		}
	}

	protected setupEvents(): void {
		super.setupEvents();
	}

	protected onSpinButtonClicked(): void {
		if ((this.module as RecodeSpinButtonModule).hasSpinTimeRegulation()) {
			if ((this.module as RecodeSpinButtonModule).regulationCanSpin) {
				if (this.module.validateSpinPress()) {
					this.trySpinIfEnoughMoneyElseEmitNotEnough();
				}
			}
		} else {
			if (this.module.validateSpinPress()) {
				this.trySpinIfEnoughMoneyElseEmitNotEnough();
			}
		}
	}

	protected onReelsSpinStarted(): void {
		if ((this.module as RecodeSpinButtonModule).hasSpinTimeRegulation()) {
			(this.module as RecodeSpinButtonModule).regulationCanSpin = false;
			(this.module as RecodeSpinButtonModule).startRegulationSpinTimer();
		}

		super.onReelsSpinStarted();
	}
}



// WEBPACK FOOTER //
// ./src/spinbutton/states/RecodeSpinButtonBasicState.ts